import { Helmet } from 'react-helmet-async';
import { useParams, Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { servicesApi } from '../lib/api';
import ReactMarkdown from 'react-markdown';
import { ContactForm } from '../components/ContactForm';

export function ServiceDetailPage() {
  const { slug } = useParams<{ slug: string }>();
  const { data: service, isLoading } = useQuery({
    queryKey: ['service', slug],
    queryFn: () => servicesApi.getBySlug(slug!).then((res) => res.data),
    enabled: !!slug,
  });

  if (isLoading) {
    return (
      <div className="container-custom py-12 text-center">Yükleniyor...</div>
    );
  }

  if (!service) {
    return (
      <div className="container-custom py-12 text-center">
        <h1 className="text-2xl font-bold mb-4">Hizmet bulunamadı</h1>
        <Link to="/cozumler" className="btn btn-primary">
          Çözümler Sayfasına Dön
        </Link>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{service.title} - {import.meta.env.VITE_APP_NAME || 'KUMBİLGİ'}</title>
        <meta name="description" content={service.summary} />
      </Helmet>

      <div className="container-custom py-12">
        {/* Breadcrumbs */}
        <nav className="mb-6 text-sm text-gray-600">
          <Link to="/" className="hover:text-primary-600">Ana Sayfa</Link>
          {' / '}
          <Link to="/cozumler" className="hover:text-primary-600">Çözümler</Link>
          {' / '}
          <span className="text-gray-900">{service.title}</span>
        </nav>

        {/* Hero Image */}
        {service.images?.[0] && (
          <div className="mb-8 rounded-lg overflow-hidden">
            <img
              src={service.images[0].url}
              alt={service.images[0].altText || service.title}
              className="w-full h-96 object-cover"
            />
          </div>
        )}

        {/* Content */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <h1 className="text-4xl font-bold mb-4">{service.title}</h1>
            <p className="text-xl text-gray-600 mb-8">{service.summary}</p>

            <div className="prose max-w-none">
              <ReactMarkdown>{service.content}</ReactMarkdown>
            </div>

            {/* Additional Images */}
            {service.images && service.images.length > 1 && (
              <div className="mt-8 grid grid-cols-2 gap-4">
                {service.images.slice(1).map((image: any) => (
                  <img
                    key={image.id}
                    src={image.url}
                    alt={image.altText || service.title}
                    className="w-full h-64 object-cover rounded-lg"
                  />
                ))}
              </div>
            )}
          </div>

          {/* Sidebar - Contact Form */}
          <div className="lg:col-span-1">
            <div className="bg-gray-50 rounded-lg p-6 sticky top-24">
              <h2 className="text-2xl font-bold mb-4">Teklif Alın</h2>
              <p className="text-gray-600 mb-6">
                Bu hizmet hakkında daha fazla bilgi almak için formu doldurun.
              </p>
              <ContactForm serviceSlug={service.slug} />
            </div>
          </div>
        </div>

        {/* CTA Banner */}
        <div className="mt-12 bg-primary-600 text-white rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold mb-6">Hemen İletişime Geçin</h2>
          <Link to="/iletisim" className="btn bg-white text-primary-600 hover:bg-gray-100">
            İletişim Formu
          </Link>
        </div>
      </div>
    </>
  );
}

